import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
declare function init_plugins();

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  isLogin: boolean = false;
  user: any = {};
  d: Date = new Date();
  year: number;
  loadAPI: Promise<any>;
  gestion: string = '';
  idleState = 'no iniciada';
  constructor(private _router: Router) {
  }
  ngOnInit() {

    init_plugins();        
    this.year = this.d.getFullYear();
    if (localStorage.getItem('u') != null) {
      this.isLogin = true;
      this.user = JSON.parse(localStorage.getItem('u'));
      this.gestion = 'Gestión: ' + localStorage.getItem('g');
      init_plugins();    
    }
    else {
      if (window.location.href.indexOf('auth') == -1) {
        this._router.navigate(['login']);
      }
    }
  }
  
  ngAfterViewInit() {
    var app = document.createElement("script");
    app.setAttribute("id", "appSript");
    app.setAttribute("src", "assets/js/app.js");
    document.body.appendChild(app);
  }
}

